/**
 * Settings API
 *
 * Endpoint: GET /api/fetch/retrieveSettings?portalId={portalId}
 *
 * Success response shape:
 * {
 *   status: "success",
 *   message: "Settings retrieved successfully.",
 *   settings: {
 *     qr_color: "#1a5490",
 *     qr_size: 400,
 *     qr_margin: 15,
 *     logo_enabled: 1,
 *     logo_upload_id: null,
 *     last_updated: "2026-03-06 12:30:08"
 *   }
 * }
 */
import apiClient from './axiosInstance';

/**
 * Fetches saved QR code settings for a given HubSpot portal.
 * These are used to pre-populate the generator form defaults.
 *
 * @param {number|string} portalId - HubSpot portal ID
 * @returns {Promise<{
 *   qr_color: string,
 *   qr_size: number,
 *   qr_margin: number,
 *   logo_enabled: number,
 *   logo_upload_id: string|null,
 *   last_updated: string
 * }>}
 * @throws {Error} normalized error with `.message` and `.status`
 */
export const retrieveUploadedFile = async (fileId) => {
  const endpoint = `${process.env.REACT_APP_BASE_URL}/settings/retrieveUploadedFile?fileId=${fileId}`;
  console.log('Retrieving uploaded file with endpoint:', endpoint);
  const response = await apiClient.get(endpoint);

  if (response.data?.status !== "success") {
    throw new Error(
      response.data?.message || "Failed to retrieve file."
    );
  }

  return response.data;
};
